import { generateRepositoryMethods } from './repository.types.js';
export const promotionsRepositoryMethods = generateRepositoryMethods({
    getActivePromotion: {
        callMethod: 'GET',
        endpoint: '/patient/promotion/active',
    },
    checkPromotionValid: {
        callMethod: 'GET',
        endpoint: '/promotions/check-valid',
    },
});
//# sourceMappingURL=promotions.methods.js.map